const ProjectItems = [
  {
    name: 'Google Homepage',
    description: 'A replication of the Google homepage.',
    tools: ['HTML', 'CSS'],
    webURL: 'https://msniyaj.github.io/google-homepage/',
    srcCode: 'https://github.com/MsNiyaJ/google-homepage',
    image: 'bg-google',
  },
  {
    name: 'Sudoku',
    description: 'A simple sudoku game with three difficulties.',
    tools: ['React', 'Typescript', 'CSS'],
    webURL: 'https://msniyaj.github.io/sudoku/',
    srcCode: 'https://github.com/MsNiyaJ/sudoku',
    image: 'bg-sudoku',
  },
  {
    name: 'Landing Page',
    description: 'A landing page for a fictional dance company.',
    tools: ['HTML', 'CSS'],
    webURL: 'https://codepen.io/msniyaj/full/yLMWoWw',
    srcCode: 'https://codepen.io/msniyaj/pen/yLMWoWw',
    image: 'bg-landingPage',
  },
  {
    name: 'My Tasks',
    description:
      'A to-do list that allows the user to add, edit, and delete tasks. The user can also mark tasks as complete.',
    tools: ['React', 'Redux', 'Typescript'],
    webURL: 'https://msniyaj.github.io/taskmanager/',
    srcCode: 'https://github.com/MsNiyaJ/taskmanager',
    image: 'bg-myTasks',
  },
];

export default ProjectItems;
